var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMoveGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "40pt",
    width: "40pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m246.96 44.238h-106.4c-6.7188 0-12.32 5.6016-12.32 12.32v103.6c0 6.7188 5.6016 12.32 12.32 12.32h106.4c6.7188 0 12.32-5.6016 12.32-12.32v-103.6c0-6.7188-5.6016-12.32-12.32-12.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.96 208.88h-106.4c-6.7188 0-12.32 5.6016-12.32 12.32v103.6c0 6.7188 5.6016 12.32 12.32 12.32h106.4c6.7188 0 12.32-5.6016 12.32-12.32v-104.16c0-6.7188-5.6016-11.762-12.32-11.762zm-24.641 91.281h-57.68v-54.879h57.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.96 379.12h-106.4c-6.7188 0-12.32 5.6016-12.32 12.32v103.6c0 6.7188 5.6016 12.32 12.32 12.32h106.4c6.7188 0 12.32-5.6016 12.32-12.32v-104.16c0-6.1602-5.6016-11.758-12.32-11.758zm-24.641 91.277h-57.68v-54.879h57.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.8 109.2 10.641-22.398c7.2812-15.68-4.4805-33.602-21.84-31.922l-150.08 11.762c-16.238 1.1211-25.199 19.602-16.238 33.602l81.762 119.28c11.199 16.238 35.84 14.559 44.238-3.3594l10.641-21.84c2.8008-5.6016 10.078-7.2812 14.559-3.3594 34.719 29.121 56.559 72.238 56.559 120.96 0 66.078-40.879 122.64-98 146.16-11.762 5.0391-20.16 15.68-20.719 28-1.1211 22.961 21.84 39.762 43.121 30.801 81.199-32.48 138.88-112.56 138.88-205.52 0-71.68-34.16-134.96-86.801-175.84-8.4023-6.168-11.203-16.809-6.7227-26.328z"
  }), /*#__PURE__*/React.createElement("use", {
    x: "{70}",
    y: "{644}",
    inkhref: "#u"
  }, /*#__PURE__*/React.createElement("use", {
    x: 90.550781,
    y: "{644}",
    inkhref: "#b"
  }, /*#__PURE__*/React.createElement("use", {
    x: 104.359375,
    y: "{644}",
    inkhref: "#a"
  }, /*#__PURE__*/React.createElement("use", {
    x: 123.347656,
    y: "{644}",
    inkhref: "#g"
  }, /*#__PURE__*/React.createElement("use", {
    x: 142.242188,
    y: "{644}",
    inkhref: "#e"
  }, /*#__PURE__*/React.createElement("use", {
    x: 155.628906,
    y: "{644}",
    inkhref: "#a"
  }, /*#__PURE__*/React.createElement("use", {
    x: 174.617188,
    y: "{644}",
    inkhref: "#d"
  }, /*#__PURE__*/React.createElement("use", {
    x: 204.410156,
    y: "{644}",
    inkhref: "#l"
  }, /*#__PURE__*/React.createElement("use", {
    x: 224.453125,
    y: "{644}",
    inkhref: "#k"
  }, /*#__PURE__*/React.createElement("use", {
    x: 252.453125,
    y: "{644}",
    inkhref: "#j"
  }, /*#__PURE__*/React.createElement("use", {
    x: 270.292969,
    y: "{644}",
    inkhref: "#a"
  }, /*#__PURE__*/React.createElement("use", {
    x: 289.28125,
    y: "{644}",
    inkhref: "#c"
  }, /*#__PURE__*/React.createElement("use", {
    x: 308.519531,
    y: "{644}",
    inkhref: "#f"
  }, /*#__PURE__*/React.createElement("use", {
    x: 328.453125,
    y: "{644}",
    inkhref: "#g"
  }, /*#__PURE__*/React.createElement("use", {
    x: 347.347656,
    y: "{644}",
    inkhref: "#b"
  }, /*#__PURE__*/React.createElement("use", {
    x: 361.15625,
    y: "{644}",
    inkhref: "#d"
  }, /*#__PURE__*/React.createElement("use", {
    x: 381.199219,
    y: "{644}",
    inkhref: "#c"
  }, /*#__PURE__*/React.createElement("use", {
    x: 410.183594,
    y: "{644}",
    inkhref: "#t"
  }, /*#__PURE__*/React.createElement("use", {
    x: 430.351562,
    y: "{644}",
    inkhref: "#i"
  }, /*#__PURE__*/React.createElement("use", {
    x: 446.945312,
    y: "{644}",
    inkhref: "#h"
  }, /*#__PURE__*/React.createElement("use", {
    x: 466.882812,
    y: "{644}",
    inkhref: "#f"
  }, /*#__PURE__*/React.createElement("use", {
    x: 486.8125,
    y: "{644}",
    inkhref: "#a"
  }, /*#__PURE__*/React.createElement("use", {
    x: 505.804688,
    y: "{644}",
    inkhref: "#s"
  }, /*#__PURE__*/React.createElement("use", {
    x: 515.402344,
    y: "{644}",
    inkhref: "#d"
  }, /*#__PURE__*/React.createElement("use", {
    x: 535.445312,
    y: "{644}",
    inkhref: "#a"
  }, /*#__PURE__*/React.createElement("use", {
    x: 554.4375,
    y: "{644}",
    inkhref: "#b"
  }, /*#__PURE__*/React.createElement("use", {
    x: "{70}",
    y: "{672}",
    inkhref: "#r"
  }, /*#__PURE__*/React.createElement("use", {
    x: 82.183594,
    y: "{672}",
    inkhref: "#b"
  }, /*#__PURE__*/React.createElement("use", {
    x: 95.992188,
    y: "{672}",
    inkhref: "#c"
  }, /*#__PURE__*/React.createElement("use", {
    x: 115.226562,
    y: "{672}",
    inkhref: "#q"
  }, /*#__PURE__*/React.createElement("use", {
    x: 154.152344,
    y: "{672}",
    inkhref: "#e"
  }, /*#__PURE__*/React.createElement("use", {
    x: 167.535156,
    y: "{672}",
    inkhref: "#h"
  }, /*#__PURE__*/React.createElement("use", {
    x: 187.46875,
    y: "{672}",
    inkhref: "#a"
  }, /*#__PURE__*/React.createElement("use", {
    x: 216.207031,
    y: "{672}",
    inkhref: "#p"
  }, /*#__PURE__*/React.createElement("use", {
    x: 239.640625,
    y: "{672}",
    inkhref: "#c"
  }, /*#__PURE__*/React.createElement("use", {
    x: 258.878906,
    y: "{672}",
    inkhref: "#o"
  }, /*#__PURE__*/React.createElement("use", {
    x: 278.8125,
    y: "{672}",
    inkhref: "#f"
  }, /*#__PURE__*/React.createElement("use", {
    x: 308.492188,
    y: "{672}",
    inkhref: "#n"
  }, /*#__PURE__*/React.createElement("use", {
    x: 329.015625,
    y: "{672}",
    inkhref: "#b"
  }, /*#__PURE__*/React.createElement("use", {
    x: 342.820312,
    y: "{672}",
    inkhref: "#c"
  }, /*#__PURE__*/React.createElement("use", {
    x: 362.058594,
    y: "{672}",
    inkhref: "#m"
  }, /*#__PURE__*/React.createElement("use", {
    x: 371.65625,
    y: "{672}",
    inkhref: "#a"
  })))))))))))))))))))))))))))))))))))))))))), /*#__PURE__*/React.createElement("use", {
    x: 390.648438,
    y: "{672}",
    inkhref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 407.242188,
    y: "{672}",
    inkhref: "#e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoveGroup);
export default __webpack_public_path__ + "static/media/icon_move_group.854331dcac46618bda3afa2265213244.svg";
export { ForwardRef as ReactComponent };